<ng-container *ngFor="let groupCoverage of groupCoverages">
  <mfp-product-feature-multiple-coverages
    [selectedCoverage]="groupCoverage.selectedCoverage"
    placeholder="0.00"
    [description]="groupCoverage.group"
    [coverages]="groupCoverage.coverages"
    [product]="product"
    [currencyExchange]="currencyExchange"
    [disabled]="disabled"
    (coverageChange)="onCoverageChange($event)"
  ></mfp-product-feature-multiple-coverages>
</ng-container>
